import React from 'react';
import { ResponsiveLine } from '@nivo/line';
import styled from 'styled-components';

export const ToolTip = styled.div`
  padding: 1rem;
  background-color: #eceff4;
  color: #434c5e;
  box-shadow: 0px 0px 2px 0px rgba(0,0,0,0.1);
`;

export const ToolTipTitle = styled.h4`
  margin-bottom: .125rem;
  font-size: 1rem;
`;

export const ToolTipPrimary = styled.div`
  margin-bottom: .125rem;
  font-size: 1.25rem;
  font-weight: 700;
`;

export const ToolTipSecondary = styled.div`
  font-size: .75rem;
`;

const Line = (props) => {
  const { data, axisBottomLegend, axisLeftLegend, tooltipY } = props;

  return (
    <ResponsiveLine
      data={data}
      colors={['#a3be8c', '#b48ead', '#ebcb8b', '#d08770', '#bf616a']}
      margin={{ top: 32, right: 16, bottom: 70, left: 54 }}
      xScale={{
        type: 'time',
        format: '%Y-%m-%d',
        useUTC: false,
        precision: 'day',
      }}
      xFormat="time:%Y-%m-%d"
      yScale={{ type: 'linear', min: 'auto', max: 'auto', stacked: false, reverse: false }}
      axisBottom={{
        format: '%d %b',
        tickValues: 'every month',
        legend: axisBottomLegend,
        legendOffset: 36,
        legendPosition: 'middle',
        tickSize: 5,
        tickPadding: 5,
      }}
      axisLeft={{
        orient: 'left',
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: axisLeftLegend,
        legendOffset: -50,
        legendPosition: 'middle'
      }}
      lineWidth={5}
      pointSize={10}
      pointColor={{ from: 'color', modifiers: [] }}
      pointLabel="y"
      useMesh={true}
      animate={true}
      legends={[
        {
          anchor: 'top-right',
          direction: 'row',
          justify: false,
          translateX: 0,
          translateY: -32,
          itemWidth: 160,
          itemHeight: 16,
          itemsSpacing: 4,
          symbolSize: 12,
          symbolShape: 'circle',
          itemDirection: 'left-to-right',
          itemTextColor: '#434c5e',
          effects: [
            {
              on: 'hover',
              style: {
                itemBackground: 'rgba(0, 0, 0, .03)',
                itemOpacity: 1
              }
            }
          ]
        }
      ]}
      theme={{
        fontFamily: 'inherit',
        fontSize: 12,
        axis: {
          ticks: {
            text: {
              fill: "#434c5e"
            }
          },
        },
        grid: {
          line: {
            stroke: "#d8dee9",
            strokeWidth: 1,
            strokeDasharray: "4 4"
          }
        },
        crosshair: {
          line: {
            stroke: '#434c5e',
          }
        }
      }}
      tooltip={(props) => {
        return (
          <ToolTip>
            <ToolTipTitle>{props.point.serieId}</ToolTipTitle>
            <ToolTipPrimary>{props.point.data.yFormatted}{tooltipY && tooltipY}</ToolTipPrimary>
            <ToolTipSecondary>{new Date(props.point.data.xFormatted).toLocaleDateString()}</ToolTipSecondary>
          </ToolTip>
        )
      }}
    />
  )
};

export default Line;